import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
  Typography,
} from 'antd';
import {
  AccountPayableRangeDateResponse,
  AccountPayableSituationColor,
  InstallmentSituationType,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import StatusTag from '@/components/_common/StatusTag';
import { useHistory } from 'react-router-dom';
import { FloatingFormItem, InputDate } from '@/components/_common';
import { useEffect } from 'react';
import moment from 'moment';
import formatterPrice from '@/utils/number/formatterPrice';

type Props = ModalProps & {
  accountSelected?: AccountPayableRangeDateResponse;
};

function CalendarDetailPayableModal({
  open,
  onCancel,
  accountSelected,
}: Props) {
  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    if (accountSelected) {
      form.setFieldsValue({
        ...accountSelected,
        payDate: moment(accountSelected.payDate),
      });
    }
  }, [accountSelected]);

  return (
    <Modal
      title={'Visualização do Contas a Pagar'}
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form}>
        <Row
          gutter={[6, 6]}
          align="middle"
          justify="space-between"
          style={{ marginBottom: '24px' }}
        >
          <Col>
            <StatusTag
              style={{ fontSize: 20, padding: 10, marginLeft: 3 }}
              label={
                accountSelected
                  ? InstallmentSituationType[accountSelected.situation]
                  : InstallmentSituationType[
                      'domain.enums.situation_installment_payable.open'
                    ]
              }
              color={
                accountSelected
                  ? AccountPayableSituationColor[accountSelected?.situation]
                  : AccountPayableSituationColor[
                      'domain.enums.situation_installment_payable.open'
                    ]
              }
            />
          </Col>

          <Col>
            <Typography.Title level={5} style={{ margin: 0, fontSize: 25 }}>
              {`${accountSelected?.accountPayableCode}/${accountSelected?.installmentNumber}`}
            </Typography.Title>
          </Col>

          <Col span={24} style={{ marginTop: 24 }}>
            {accountSelected?.accountPayableEmployeeId ? (
              <FloatingFormItem
                label="Funcionário"
                name="accountPayableEmployeeName"
              >
                <Input disabled />
              </FloatingFormItem>
            ) : (
              <FloatingFormItem
                label="Fornecedor"
                name="accountPayableSupplierName"
              >
                <Input disabled />
              </FloatingFormItem>
            )}
          </Col>

          <Col span={24}>
            {accountSelected?.payDate && (
              <FloatingFormItem label="Data de pagamento" name="payDate">
                <InputDate disabled />
              </FloatingFormItem>
            )}
          </Col>

          <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const value = Number(getFieldValue('installmentValue'));
                const discountIncrease = Number(
                  getFieldValue('discountIncrease'),
                );

                let total = value + discountIncrease;
                if (!total) {
                  total = 0;
                }
                return (
                  <>
                    <Typography.Title level={4} style={{ marginTop: '2px' }}>
                      Valor da parcela:
                    </Typography.Title>
                    <span
                      style={{
                        color: 'rgb(160, 206, 51)',
                        fontSize: 20,
                        marginLeft: 14,
                      }}
                    >
                      {formatterPrice(value)}
                    </span>
                  </>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Button
        onClick={() =>
          history.push(
            `/app/financial/billToPay/releaseBillToPay/detail/accountPayableId/${accountSelected?.accountPayableId}/installmentPayableId/${accountSelected?.id}`,
          )
        }
        block
        type="primary"
      >
        Ir para a tela de detalhes
      </Button>
    </Modal>
  );
}

export default CalendarDetailPayableModal;
